<!----
    Author: hjlee
    Description:
        프로필 수정 폼
---->
<template>
  <xdata-update-row-control
    load-update-url="auth/profile"
    update-url="auth/profile"
    :show-cancel-button="false"
    :show-update-button="true"
    :dont-check-author="true"
    :step="step"
    :next-step="nextStep"
    :next-button-name="nextButtonName"
    :save-button-name="saveButtonName"
    :camera-button-image="cameraButtonImage"
    :show-circle="true"
    :show-image-viewer="showImageViewer"
    :cover-image="coverImage"
    module="user"
    item="user"
    @updated="updated"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: undefined
    },
    onUpdated: {
      type: String,
      default: ''
    },
    onNext: {
      type: String,
      default: ''
    },
    step: {
      type: String,
      default: ''
    },
    nextStep: {
      type: String,
      default: ''
    },
    saveButtonName: {
      type: String,
      default: ''
    },
    nextButtonName: {
      type: String,
      default: ''
    },
    cameraButtonImage: {
      type: String,
      default: undefined
    },
    showImageViewer: {
      type: Boolean,
      default: true
    },
    coverImage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputVal: {}
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.inputVal = newVal
      },
      immediate: true,
      deep: true
    },
    inputVal: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
        this.$emit('input', oldVal)
      },
      deep: true
    }
  },
  methods: {
    updated(row) {
      this.$store.commit('SET_USER', row)
      if (this.onUpdated && window.onEvent && window.onEvent[this.onUpdated]) {
        window.onEvent[this.onUpdated](row)
      }
    },
    onNextStep(obj) {
      if (this.onNext && window.onEvent && window.onEvent[this.onNext]) {
        window.onEvent[this.onNext](obj)
      }
    }
  }
}
</script>
